import React, { useState, useEffect, useCallback } from 'react';
import { setGoogleSignInCallback, renderGoogleSignInButton } from '../utils/googleSignIn';

const API_BASE = process.env.REACT_APP_API_URL || '';

function Login({ onLogin, onRegister, onGoogleRegister }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleGoogleResponse = useCallback(async (response) => {
    setError('');
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE}/api/auth/google`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ credential: response.credential })
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error || 'Google sign-in failed');
      }

      if (data.needsRegistration) {
        // New user - needs to complete registration
        onGoogleRegister(response.credential, data.email, data.name, data.picture);
      } else {
        // Existing user - logged in
        onLogin(data.user, data.token);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [onLogin, onGoogleRegister]);

  useEffect(() => {
    setGoogleSignInCallback(handleGoogleResponse);
    const container = document.getElementById('google-signin-btn');
    let cancelled = false;

    renderGoogleSignInButton(container, { text: 'signin_with' }).catch(() => {});

    return () => {
      cancelled = true;
      if (cancelled && container) container.innerHTML = '';
    };
  }, [handleGoogleResponse]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Login failed');
      }

      onLogin(data.user, data.token);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>Product Selection</h1>
        <p>Sign in to continue</p>

        {error && (
          <div className="error-message">{error}</div>
        )}

        {/* Google Sign-In Button */}
        <div className="google-signin-wrapper">
          <div id="google-signin-btn"></div>
        </div>

        <div className="divider">
          <span>or sign in with email</span>
        </div>

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Email (@printo.in / @canvera.com)"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <div className="login-footer">
          <p>Don't have an account?</p>
          <button
            type="button"
            className="link-btn"
            onClick={onRegister}
          >
            Register here
          </button>
        </div>
      </div>
    </div>
  );
}

export default Login;
